/**
 * 【KYMW1400】計画値集計表取得VO
 *
 * @export PlanSummaryTableModel
 * @class PlanSummaryTableModel
 */
export class PlanSummaryTableModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   * ページ番号
   */
  public pageNum = Number(0);
}
